import React, { useState, useEffect, useRef } from 'react';
import ChessBoard from "chessboardjsx";
import Chess from "chess.js";
import "bootstrap/dist/css/bootstrap.min.css";
import FindPlayers from "./FindPlayers"
/*import ViewPlayerGames from "./ViewPlayerGames"*/
import { Stack, TextField, Paper, Card, CardContent, CardActions, Button, ButtonGroup, Box, FormControl, FormLabel, FormControlLabel, RadioGroup, Radio, Accordion, AccordionSummary, AccordionDetails} from '@mui/material'
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import authService from './api-authorization/AuthorizeService'
import axios from 'axios'



const results = [
    { value: '1-0', label: '1-0' },
    { value: '1/2-1/2', label: '1/2-1/2' },
    { value: '0-1', label: '0-1' },
    { value: '*', label: '*' },
];

export default function InputGame({ width = 800 }) {
    const [whitePlayer, setWhitePlayer] = useState();
    const [blackPlayer, setBlackPlayer] = useState();
    const [eventName, setEventName] = useState();
    const [eventDate, setEventDate] = useState();
    const [white, setWhite] = useState();
    const [whiteElo, setWhiteElo] = useState();
    const [whiteFideId, setWhiteFideId] = useState();
    const [whiteUscfId, setWhiteUscfId] = useState();
    const [black, setBlack] = useState();
    const [blackElo, setBlackElo] = useState();
    const [blackFideId, setBlackFideId] = useState();
    const [blackUscfId, setBlackUscfId] = useState();
    const [round, setRound] = useState();
    const [section, setSection] = useState();
    const [site, setSite] = useState();
    const [currentFen, setCurrentFen] = useState("start");
    const [fenArray, setFenArray] = useState([]);
    const [moves, setMoves] = useState([]);
    const [notations, setNotations] = useState([]);
    const [currentMove, setCurrentMove] = useState(0);
    const [totalMoves, setTotalMoves] = useState(0);
    const [pgnOutput, setPgnOutput] = useState();
    const [header, setHeader] = useState(null);
    const [result, setResult] = useState();
    const [event, setEvent] = useState();
    const [date, setDate] = useState(((new Date()).toISOString().split("T")[0]).replaceAll("-", "."));
    const [fen, setFen] = useState("start");
    const [history, setHistory] = useState([]);
    const [pgn, setPgn] = useState();
    const [pgnForUpload, setPgnForUpload] = useState();
    const [playerConfirmed, setPlayerConfirmed] = useState(false);
    const [whitePlayerConfirmed, setWhitePlayerConfirmed] = useState(false);
    const [blackPlayerConfirmed, setBlackPlayerConfirmed] = useState(false);
    const [importStatus, setImportStatus] = useState("");
    const [token, setToken] = useState();
    const [waiting, setWaiting] = useState(false);


    let game = useRef(null);
    
    //https://stackoverflow.com/questions/63570597/typeerror-func-apply-is-not-a-function
    //useEffect(() => {
    //    game.current = new Chess();
    //    setFenArray(["start"]); //empty the fenArray array
    //    setCurrentFen("start");
    //    setToken(authService.getAccessToken());
    //}, []); //Runs only on the first render or props changes


    /*useEffect(async () => {*/
    useEffect( () => {
        game.current = new Chess();
        setFenArray(["start"]); //empty the fenArray array
        setCurrentFen("start");
        setToken(authService.getAccessToken());
    }, []);


    async function makeMove(direction) {
        switch (direction) {
            case "start":
                await setCurrentMove(0);
                await setCurrentFen(fenArray[0]);
                break;

            case "prev":
                if (currentMove > 0) {
                    await setCurrentFen(fenArray[currentMove - 1]);
                    await setCurrentMove(currentMove - 1);
                }
                break;

            case "next":
                if (currentMove < totalMoves) {
                    await setCurrentFen(fenArray[currentMove + 1]);
                    await setCurrentMove(currentMove + 1);
                }
                break;

            case "end":
                await setCurrentFen(fenArray[totalMoves]);
                await setCurrentMove(totalMoves);
                break;

            default:
                if (currentMove < totalMoves) {
                    await setCurrentFen(fenArray[currentMove + 1]);
                    await setCurrentMove(currentMove + 1);
                }
        }
    }

    async function handleKey(e) {
        var key = e.keyCode;
        switch (key) {
            case 37: //left
                await makeMove("prev")
                break;
            case 38: //up
                await makeMove("start")
                break;
            case 39: //right
                await makeMove("next")
                break;
            case 40: //down
                await makeMove("end")
                break;
            default:
                break;
        }
    }

    function onDrop({ sourceSquare, targetSquare }) {
        // see if the move is legal
        let move = game.current.move({
            from: sourceSquare,
            to: targetSquare,
            promotion: "q" // always promote to a queen for example simplicity https://stackoverflow.com/questions/63085825/is-there-a-way-to-enable-underpromotions-using-chess-js  https://github.com/jhlywa/chess.js/issues/131
        });
        if (move != null || totalMoves ==0) { //just started or make a legal/same move
            var newGame = new Chess();
            let array = fenArray;
            array.push(game.current.fen())
            setCurrentFen(game.current.fen());
            let h = game.current.history(); //{ verbose: true });
            setHistory(h);
            setFenArray(array);

            let notes = [];
            let totalFullMoves = Math.floor(h.length / 2);
            for (var i = 0; i < totalFullMoves; i++) {
                let fullMove = { moveIndex: i + 1, white: h[2 * i], black: h[2 * i + 1] };
                notes.push(fullMove);
            }
            if (h.length % 2 == 1) {
                let lastFullMove = { moveIndex: totalFullMoves + 1, white: h[h.length - 1], black: "" };
                notes.push(lastFullMove);
            }
            setTotalMoves(h.length);
            setNotations(notes);
            /*setCurrentMove(0);*/
            setFenArray(array); //empty the fenArray array

            console.log(fen);
            console.log(JSON.stringify(history));
            console.log(JSON.stringify(fenArray));
            console.log(JSON.stringify(game.current.pgn()));
            let pgntemp = game.current.pgn();
            setPgn(pgntemp); //JSON.stringify(game2.current.pgn()));
            setCurrentMove(currentMove + 1);
        }
        else //overwrite moves with different one
        {
            let lll = game.current.history().length;
            let array = fenArray;
            for (var j = (lll-1) ; j >= currentMove; j--)
            {
                game.current.undo();
                
            }
            for (j = lll; j > currentMove; j--) {
                array.pop();
            }
            
            let move2 = game.current.move({
                from: sourceSquare,
                to: targetSquare,
                promotion: "q" // always promote to a queen for example simplicity
            });

            var newGame = new Chess();
            array.push(game.current.fen())
            setCurrentFen(game.current.fen());
            let h = game.current.history(); //{ verbose: true });
            setHistory(h);
            setFenArray(array);

            let notes = [];
            let totalFullMoves = Math.floor(h.length / 2);
            for (i = 0; i < totalFullMoves; i++) {
                let fullMove = { moveIndex: i + 1, white: h[2 * i], black: h[2 * i + 1] };
                notes.push(fullMove);
            }
            if (h.length % 2 == 1) {
                let lastFullMove = { moveIndex: totalFullMoves + 1, white: h[h.length - 1], black: "" };
                notes.push(lastFullMove);
            }
            setTotalMoves(h.length);
            setNotations(notes);
            /*setCurrentMove(0);*/
            setFenArray(array); //empty the fenArray array

            console.log(fen);
            console.log(JSON.stringify(history));
            console.log(JSON.stringify(fenArray));
            console.log(JSON.stringify(game.current.pgn()));
            let pgntemp = game.current.pgn();
            setPgn(pgntemp); //JSON.stringify(game2.current.pgn()));
            setCurrentMove(currentMove + 1);
        }
        
        
    };

    const importChessGame = async (e) => {
        e.preventDefault()

        var gameSource = (event + "."+date).replaceAll(" ","");
        var pgnString = '[Event "' + event + '"]' + '\n';
        if (section)
            pgnString = '[Event "' + event + " - " + section + '"]' + '\n';
        pgnString += '[Site "' + site + '"]' + '\n';
        pgnString += '[Date "'+date+'"]'  + '\n';
        pgnString += '[Round "' + round+'"]' + '\n';
        pgnString += '[Result "' + result + '"]' + '\n';
        if (whitePlayer.fideName)
            pgnString += '[White "' + whitePlayer.fideName + '"]' + '\n';
        else
            pgnString += '[White "' + whitePlayer.uscfName + '"]' + '\n';

        if (whitePlayer.fidePlayerId > 0)
            pgnString += '[WhiteFideId "' + whitePlayer.fidePlayerId + '"]' + '\n';

        if (whitePlayer.uscfPlayerId > 0)
            pgnString += '[WhiteUscfId "' + whitePlayer.uscfPlayerId + '"]' + '\n';

        if (whitePlayer.fideRating > whitePlayer.uscfRating)
            pgnString += '[WhiteElo "' + whitePlayer.fideRating + '"]' + '\n';
        else
            pgnString += '[WhiteElo "' + whitePlayer.uscfRating + '"]' + '\n';

        //black
        if (blackPlayer.fideName)
            pgnString += '[Black "' + blackPlayer.fideName + '"]' + '\n';
        else
            pgnString += '[Black "' + blackPlayer.uscfName + '"]' + '\n';

        if (blackPlayer.fidePlayerId > 0)
            pgnString += '[BlackFideId "' + blackPlayer.fidePlayerId + '"]' + '\n';

        if (blackPlayer.uscfPlayerId > 0)
            pgnString += '[BlackUscfId "' + blackPlayer.uscfPlayerId + '"]' + '\n';

        if (blackPlayer.fideRating > blackPlayer.uscfRating)
            pgnString += '[BlackElo "' + blackPlayer.fideRating + '"]' + '\n';
        else
            pgnString += '[BlackElo "' + blackPlayer.uscfRating + '"]' + '\n';

        pgnString += '\n\n' + pgn + " " + result;

        const formData = new FormData();
        formData.append("pgnString", pgnString);
        formData.append("gameSource", gameSource);

        setToken(await authService.getAccessToken());
        var headers = {
            headers: { 'Authorization': `Bearer ${token}`, "Content-Type": "multipart/form-data" }
        }
        setWaiting(true);
        try {
            //const response = await axios({ method: "post", url: "/api/ChessGames/uploadPGN", data: formData, headers: headers }); //{ "Content-Type": "multipart/form-data", 'Authorization': `Bearer ${token}`   }, });
            const response = await axios({ method: "post", url: "/api/ChessGames/ImportChessGame", data: formData, headers: { 'GameSource': `${gameSource}`, "Content-Type": "multipart/form-data", 'Authorization': `Bearer ${token}` }, });
            setImportStatus(response.data);
            alert(response.data);
            setWaiting(false);
            setFenArray(["start"]); //empty the fenArray array
            setCurrentFen("start");
            setMoves([]);
            setCurrentMove(0);
            setTotalMoves(0);
            game.current = new Chess();
            setPgn();
            setResult();
            setNotations([]);
        } catch (error) {
            console.log(error)
            setImportStatus(error.response.data);
            alert(error.response.data);
            setWaiting(false);
        }
    }

    const values = {
        someDate: new Date().toISOString().substring(0, 10)
    };
    return (
        <Box my={2}>
        <Paper my={2} elevation={3} onKeyDown={async (e) => { await handleKey(e) }}>
                {/*<div className="container" style={{ flex: 1, alignItems: 'center', justifyContent: 'center' }} onKeyDown={async (e) => { await handleKey(e) }}>*/}

                <Accordion m={2} pt={3} pl={3} pr={3} defaultExpanded={true}>
                    <AccordionSummary aria-controls="event-info" id="event-info" expandIcon={<ExpandMoreIcon />}>
                        <Typography color='primary'>Event Info</Typography>
                        <Typography>{(event ? ' : ' + event : '') + (section ? ' [Section - ' + section + ']' : '') + (round ? ' [Round - ' + round + ']' : '') + (site ? ' [Site - ' + site + ']' : '') + (date && event ? ' [Date - ' + date + ']' : '')}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Stack m={2} pt={3} direction={{ xs: "column", sm: "column", md: "row" }} spacing={2}>
                            <TextField
                                required
                                fullwidth
                                size="small"
                                label='Event'
                                InputLabelProps={{ shrink: true, }}
                                variant='outlined'
                                value={event}
                                onChange={async (e) => { await setEvent(e.target.value) }}
                                error={!event}
                                helperText={!event ? 'Required' : ''}
                            />
                            <TextField
                                required
                                fullwidth
                                size="small"
                                label='Section'
                                InputLabelProps={{ shrink: true, }}
                                variant='outlined'
                                value={section}
                                onChange={async (e) => { await setSection(e.target.value) }}
                                error={!section}
                                helperText={!section ? 'Required' : ''}
                            />
                            <TextField
                                fullwidth
                                size="small"
                                label='Round'
                                variant='outlined'
                                InputLabelProps={{ shrink: true, }}
                                type='number'
                                value={round}
                                onChange={async (e) => { await setRound(e.target.value) }}
                                error={!round}
                                helperText={!round ? 'Required' : ''}
                            />
                            <TextField
                                required
                                fullwidth
                                size="small"
                                label='Site'
                                variant='outlined'
                                InputLabelProps={{ shrink: true, }}
                                value={site}
                                onChange={async (e) => { await setSite(e.target.value) }}
                                error={!site}
                                helperText={!site ? 'Required' : ''}
                            />
                            <TextField
                                required
                                fullwidth
                                size="small"
                                label='Date'
                                InputLabelProps={{ shrink: true, }}
                                variant='outlined'
                                type='date'
                                value={date.replaceAll(".", "-")}
                                onChange={async (e) => { await setDate(e.target.value.replaceAll("-", ".")) }}
                                error={!date}
                                helperText={!date ? 'Required' : ''}
                            />
                        </Stack>
                    </AccordionDetails>
                </Accordion>
                <Accordion m={2} pt={3} pl={3} pr={3} defaultExpanded={true}>
                    <AccordionSummary aria-controls="player-info" id="player-info" expandIcon={<ExpandMoreIcon />}>
                        <Typography color='primary'>Player Info</Typography>
                        {whitePlayer && blackPlayer &&
                            <Typography>
                                {" : " + (whitePlayer.fideTitle ? whitePlayer.fideTitle + " " : "") + (whitePlayer.fideName ? whitePlayer.fideName : whitePlayer.uscfName) + (whitePlayer.fideRating > 0 ? " [" + whitePlayer.fideRating + "] " : " [" + whitePlayer.uscfRating + "] ") + (whitePlayer.fideCountry ? " [" + whitePlayer.fideCountry + "] " : "") + (whitePlayer.uscfState ? "[" + whitePlayer.uscfState + "] " : "")
                                    + " " + result + " " +
                                    (blackPlayer.fideTitle ? blackPlayer.fideTitle + " " : "") + (blackPlayer.fideName ? blackPlayer.fideName : blackPlayer.uscfName) + (blackPlayer.fideRating > 0 ? " [" + blackPlayer.fideRating + "] " : " [" + blackPlayer.uscfRating + "] ") + (blackPlayer.fideCountry ? " [" + blackPlayer.fideCountry + "] " : "") + (blackPlayer.uscfState ? "[" + blackPlayer.uscfState + "] " : "")}
                            </Typography>
                        }
                    </AccordionSummary>
                    <AccordionDetails>
                        <Stack fullwidth m={1} direction={{ xs: "column", sm: "column", md: "row" }} spacing={2} alignItems="center">
                            {whitePlayer &&
                                <Card >
                                    <CardContent style={{ borderColor: "white" }}>
                                        <TextField
                                            variant='outlined'
                                            size='small'
                                            label='White Player'
                                            readOnly
                                            fullwidth
                                            value={(whitePlayer.fideTitle ? whitePlayer.fideTitle + " " : "") + (whitePlayer.fideName ? whitePlayer.fideName : whitePlayer.uscfName) + (whitePlayer.fideCountry ? " [" + whitePlayer.fideCountry + "] " : "") + (whitePlayer.uscfState ? "[" + whitePlayer.uscfState + "] " : "")}
                                            helperText={(whitePlayer.fidePlayerId ? '[FIDE#' + whitePlayer.fidePlayerId + "|Elo " + whitePlayer.fideRating + "]" : "[FIDE#000000|Elo 0000]") + (whitePlayer.uscfPlayerId ? '[USCF#' + whitePlayer.uscfPlayerId + "|Rating " + whitePlayer.uscfRating + "]" : "[USCF#00000000|Rating 0000")}
                                        >
                                        </TextField>
                                    </CardContent>
                                    <CardActions>
                                        <ButtonGroup variant='text' size='small' color='primary'>
                                            {whitePlayer && !whitePlayerConfirmed &&
                                                <Button variant='contained' onClick={async () => { await setWhitePlayerConfirmed(true); }}>Confirm</Button>
                                            }
                                            {whitePlayer && whitePlayerConfirmed &&
                                                <Button onClick={async () => { await setWhitePlayerConfirmed(false); /*await setWhitePlayer(null);*/ }}>Change</Button>
                                            }
                                        </ButtonGroup>
                                    </CardActions>
                                </Card>
                            }
                            {whitePlayerConfirmed && blackPlayerConfirmed &&
                                <Card >
                                    <CardContent style={{ borderColor: "white" }}>
                                        <FormControl>

                                            <RadioGroup row name='result-radio-group' value={result} onChange={(e) => setResult(e.target.value)}>
                                                <FormControlLabel control={<Radio checked={result == '1-0'} size='small' color='primary' />} label='1-0' value='1-0' />
                                                <FormControlLabel control={<Radio checked={result == '1/2-1/2'} size='small' color='secondary' />} label='Draw' value='1/2-1/2' />
                                                <FormControlLabel control={<Radio checked={result == '0-1'} size='small' color='primary' />} label='0-1' value='0-1' />
                                            </RadioGroup>
                                        </FormControl>
                                    </CardContent>
                                    <CardActions >
                                        <ButtonGroup variant='text' size='small' color='primary'>
                                            {blackPlayer && whitePlayer && blackPlayerConfirmed && whitePlayerConfirmed &&
                                                <Button onClick={async () => { var tmpPlayer = whitePlayer; await setWhitePlayer(blackPlayer); await setBlackPlayer(tmpPlayer) }}>Switch Color</Button>
                                            }
                                        </ButtonGroup>
                                    </CardActions>
                                </Card>
                            }
                            {blackPlayer &&
                                <Card >
                                    <CardContent style={{ borderColor: "black" }}>
                                        <TextField
                                            variant='outlined'
                                            size='small'
                                            label='Black Player'
                                            readOnly
                                            fullwidth
                                            value={(blackPlayer.fideTitle ? blackPlayer.fideTitle + " " : "") + (blackPlayer.fideName ? blackPlayer.fideName : blackPlayer.uscfName) + (blackPlayer.fideCountry ? " [" + blackPlayer.fideCountry + "] " : "") + (blackPlayer.uscfState ? "[" + blackPlayer.uscfState + "] " : "")}
                                            helperText={(blackPlayer.fidePlayerId ? '[FIDE#' + blackPlayer.fidePlayerId + "|Elo " + blackPlayer.fideRating + "]" : "[FIDE#000000|Elo 0000]") + (blackPlayer.uscfPlayerId ? '[USCF#' + blackPlayer.uscfPlayerId + "|Rating " + blackPlayer.uscfRating + "]" : "[USCF#00000000|Rating 0000")}
                                        >
                                        </TextField>
                                    </CardContent>
                                    <CardActions>
                                        <ButtonGroup variant='text' size='small' color='primary'>
                                            {blackPlayer && !blackPlayerConfirmed &&
                                                <Button variant='contained' onClick={async () => { await setBlackPlayerConfirmed(true); }}>Confirm</Button>
                                            }
                                            {blackPlayer && blackPlayerConfirmed &&
                                                <Button onClick={async () => { await setBlackPlayerConfirmed(false); /*await setBlackPlayer(null); */ }}>Change</Button>
                                            }
                                        </ButtonGroup>
                                    </CardActions>
                                </Card>
                            }
                        </Stack>
                        <Stack direction="column">
                            {!whitePlayerConfirmed &&
                                <div><FindPlayers sendToParentSelectedPlayer={setWhitePlayer} searchButtonCaption={"Search White Player"} /></div>
                            }
                            {!blackPlayerConfirmed &&
                                <div><FindPlayers sendToParentSelectedPlayer={setBlackPlayer} searchButtonCaption={"Search Black Player"} /></div>
                            }
                        </Stack>
                        {/*<Stack>*/}
                        {/*    {whitePlayer && blackPlayer && whitePlayerConfirmed && blackPlayerConfirmed &&*/}
                        {/*        <div>*/}
                        {/*            <ViewPlayerGames*/}
                        {/*                key={whitePlayer.fidePlayerId + whitePlayer.uscfPlayerId + blackPlayer.fidePlayerId + blackPlayer.uscfPlayerId}*/}
                        {/*                idType={whitePlayer.fidePlayerId > 0 ? "FIDE" : "USCF"}*/}
                        {/*                playerId={whitePlayer.fidePlayerId > 0 ? whitePlayer.fidePlayerId : whitePlayer.uscfPlayerId}*/}
                        {/*                opponentIdType={blackPlayer.fidePlayerId > 0 ? "FIDE" : "USCF"}*/}
                        {/*                opponentPlayerId={blackPlayer.fidePlayerId > 0 ? blackPlayer.fidePlayerId : blackPlayer.uscfPlayerId}*/}
                        {/*            />*/}
                        {/*        </div>*/}
                        {/*    }*/}
                        {/*</Stack>*/}
                    </AccordionDetails>
                </Accordion>
                <Accordion m={2} pt={3} pl={3} pr={3} defaultExpanded={false}>
                    <AccordionSummary aria-controls="input-move" id="input-move" expandIcon={<ExpandMoreIcon />}>
                        <Typography color='primary'>{'Input Moves' + (totalMoves > 0 ? ' : '+totalMoves:'') }</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                    {/*{whitePlayerConfirmed && blackPlayerConfirmed && result &&*/}
                        <div className="table-responsive">
                            {/*<table className="table">*/}
                            <table className="table" onKeyDown={async (e) => { await handleKey(e) }}>
                                <tbody>
                                    <tr align="center">
                                        <td align="center">
                                            <div>
                                                {whitePlayer && <span ><strong>{whitePlayer.fideName ? whitePlayer.fideName : whitePlayer.uscfName}&nbsp;&nbsp;</strong></span>}
                                                {result}
                                                {blackPlayer && <span><strong>&nbsp;&nbsp;{blackPlayer.fideName ? blackPlayer.fideName : blackPlayer.uscfName}</strong></span>}
                                                {<span>{('[Event ' + event + ']')}{('[Section ' + section + ']')}{('[Round ' + round + ']')}</span>}
                                            </div>
                                        </td>
                                        <td>
                                        </td>
                                        <td>
                                        </td>
                                    </tr>
                                    <tr align="center">
                                        <td align="center" valign="top">
                                            <div tabIndex="0"><ChessBoard position={currentFen} onDrop={onDrop} showNotation="true" width={width} /></div>
                                            {/*<div>*/}
                                            {/*    {event && <span>[Event "{event}"]</span>}*/}
                                            {/*    {site && <span>[Site "{site}"]</span>}*/}
                                            {/*    */}{/*{date && <span>[Date "{date}"]</span>}*/}
                                            {/*    {round && <span>[Round "{round}"]</span>}*/}
                                            {/*    {result && <span>[Result "{result}"]</span>}*/}
                                            {/*    {whitePlayer && <span>[White "{whitePlayer.fideName ? whitePlayer.fideName : whitePlayer.uscfName}"]</span>}*/}
                                            {/*    {whitePlayer && whitePlayer.fidePlayerId > 0 && < span > [WhiteFideId "{whitePlayer.fidePlayerId}"]</span>}*/}
                                            {/*    {whitePlayer && whitePlayer.uscfPlayerId > 0 && < span > [WhiteUscfId "{whitePlayer.uscfPlayerId}"]</span>}*/}
                                            {/*    {whitePlayer && <span>[WhiteElo "{whitePlayer.fideRating > whitePlayer.uscfRating ? whitePlayer.fideRating : whitePlayer.uscfRating}"]</span>}*/}
                                            {/*    {blackPlayer && <span>[Black "{blackPlayer.fideName ? blackPlayer.fideName : blackPlayer.uscfName}"]</span>}*/}
                                            {/*    {blackPlayer && blackPlayer.fidePlayerId > 0 && < span > [BlackFideId "{blackPlayer.fidePlayerId}"]</span>}*/}
                                            {/*    {blackPlayer && blackPlayer.uscfPlayerId > 0 && < span > [BlackUscfId "{blackPlayer.uscfPlayerId}"]</span>}*/}
                                            {/*    {blackPlayer && <span>[BlackElo "{blackPlayer.fideRating > blackPlayer.uscfRating ? blackPlayer.fideRating : blackPlayer.uscfRating}"]</span>}*/}
                                            {/*</div>*/}
                                            {/*<div>*/}
                                            {/*    <p>{pgn}{" "}{result}</p>*/}
                                            {/*</div>*/}
                                        </td>
                                        <td>
                                        </td>
                                        <td align="left" valign="top" style={{ maxHeight: width, overflow: 'auto', display: 'inline-block' }}>
                                            <table className='table table-sm table-striped table-bordered' aria-labelledby="tabelLabel">
                                                <thead className="thead-dark" style={{ position: 'sticky', top: 0 }}>
                                                    <tr>
                                                        <th nowrap="nowrap" style={{ "textAlign": "center" }}>#</th>
                                                        <th nowrap="nowrap" style={{ "textAlign": "center" }}>White</th>
                                                        <th nowrap="nowrap" style={{ "textAlign": "center" }}>Black</th>
                                                    </tr >
                                                </thead >
                                                <tbody>
                                                    {notations.map((singleMove, index) =>
                                                        <tr key={singleMove.index}>
                                                            <td nowrap="nowrap" style={{ "textAlign": "right" }} ><span>{singleMove.moveIndex}</span></td>
                                                            <td nowrap="nowrap" style={{ "textAlign": "center" }} className={currentMove === (singleMove.moveIndex - 1) * 2 + 1 ? "table-info" : null} tabindex={(singleMove.moveIndex - 1) * 2 + 1} onKeyDown={async (e) => { await handleKey(e) }}><span className="btn btn-link" onClick={async (e) => { await setCurrentFen(fenArray[(singleMove.moveIndex - 1) * 2 + 1]); await setCurrentMove((singleMove.moveIndex - 1) * 2 + 1) }}>{singleMove.white}</span></td>
                                                            <td nowrap="nowrap" style={{ "textAlign": "center" }} className={currentMove === (singleMove.moveIndex - 1) * 2 + 2 ? "table-info" : null} tabindex={(singleMove.moveIndex - 1) * 2 + 2} onKeyDown={async (e) => { await handleKey(e) }}><span className="btn btn-link" onClick={async (e) => { await setCurrentFen(fenArray[(singleMove.moveIndex - 1) * 2 + 2]); await setCurrentMove((singleMove.moveIndex - 1) * 2 + 2) }}>{singleMove.black}</span></td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr align="center">
                                        <td>
                                            <button className="btn btn-primary mt-1 mb-1" disabled={currentMove <= 0} onClick={async () => { await makeMove("start") }}>Start Position</button>
                                            <button className="btn btn-primary ml-1 mt-1 mb-1" disabled={currentMove <= 0} onClick={async () => { await makeMove("prev") }}>Previous Move</button>
                                            <button className="btn btn-primary ml-1 mt-1 mb-1" disabled={currentMove >= totalMoves} onClick={async () => { await makeMove("next") }}>Next Move</button>
                                            <button className="btn btn-primary ml-1 mt-1 mb-1" disabled={currentMove >= totalMoves} onClick={async () => { await makeMove("end") }}>End Position</button>
                                            <button className="btn btn-success ml-1 mt-1 mb-1" disabled={!result || !whitePlayer || !blackPlayer || !pgn || !event || !date} onClick={importChessGame}>Import to MetaDB</button>
                                        </td>
                                        <td>
                                        </td>
                                        <td>
                                            {result &&
                                                <table className='table table-sm table-striped table-bordered' aria-labelledby="tabelLabel">
                                                    <thead className="thead-dark">
                                                        <tr>
                                                            <th nowrap="nowrap" style={{ "textAlign": "center" }}>{result}</th>
                                                        </tr >
                                                    </thead >
                                                </table>
                                            }
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <p>{importStatus}</p>
                                        </td>
                                        <td>
                                        </td>
                                        <td>
                                        </td>
                                    </tr>

                                </tbody>
                            </table>
                            {/*</table>*/}
                        </div>
                    {/*}*/}
                    </AccordionDetails>
                </Accordion>
                <Accordion m={2} pt={3} pl={3} pr={3} defaultExpanded={false}>
                <AccordionSummary aria-controls="pgn" id="pgn" expandIcon={<ExpandMoreIcon />}>
                    <Typography color='primary'>{'PGN'}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    {whitePlayer && blackPlayer &&
                        <Stack>
                        <TextField multiline readOnly fullwidth label='PGN String'
                            value={
                                (section ? '[Event "' + event + " - " + section + '"]' + '\n' : '[Event "' + event + '"]' + '\n')
                                + (site ? '[Site "' + site + '"]' + '\n' : '')
                                + (date ? '[Date "' + date + '"]' + '\n' : '')
                                + (round ? '[Round "' + round + '"]' + '\n' : '')
                                + (result ? '[Result "' + result + '"]' + '\n' : '')
                                + (whitePlayer.fideName ? '[White "' + whitePlayer.fideName + '"]' + '\n' : '[White "' + whitePlayer.uscfName + '"]' + '\n')
                                + (whitePlayer.fidePlayerId > 0 ? '[WhiteFideId "' + whitePlayer.fidePlayerId + '"]' + '\n' : '')
                                + (whitePlayer.uscfPlayerId > 0 ? '[WhiteUscfId "' + whitePlayer.uscfPlayerId + '"]' + '\n' : '')
                                + (whitePlayer.fideRating > whitePlayer.uscfRating ? '[WhiteElo "' + whitePlayer.fideRating + '"]' + '\n' : '[WhiteElo "' + whitePlayer.uscfRating + '"]' + '\n')

                                + (blackPlayer.fideName ? '[Black "' + blackPlayer.fideName + '"]' + '\n' : '[Black "' + blackPlayer.uscfName + '"]' + '\n')
                                + (blackPlayer.fidePlayerId > 0 ? '[BlackFideId "' + blackPlayer.fidePlayerId + '"]' + '\n' : '')
                                + (blackPlayer.uscfPlayerId > 0 ? '[BlackUscfId "' + blackPlayer.uscfPlayerId + '"]' + '\n' : '')
                                + (blackPlayer.fideRating > blackPlayer.uscfRating ? '[BlackElo "' + blackPlayer.fideRating + '"]' + '\n' : '[BlackElo "' + blackPlayer.uscfRating + '"]' + '\n')
                                + ('\n\n' + pgn + " " + result)
                            }
                        />
                        </Stack>
                    }
                </AccordionDetails>
            </Accordion>
                {/*</div>*/}
            </Paper>
        </Box>
    )
}
                {/*<table onKeyDown={async (e) => { await handleKey(e) }}>*/}
                {/*    <tbody>*/}
                {/*        <tr align="center">*/}
                {/*            <td align="center">*/}
                {/*                <span><strong>[{white}]&nbsp;&nbsp;{result}&nbsp;&nbsp;[{black}]</strong></span>*/}
                {/*            </td>*/}
                {/*            <td>*/}
                {/*            </td>*/}
                {/*            <td>*/}
                {/*            </td>*/}
                {/*        </tr>*/}
                {/*        <tr align="center">*/}
                {/*            <td align="center">*/}
                {/*                <span>[{event}]&nbsp;&nbsp;[{date}]</span>*/}
                {/*            </td>*/}
                {/*            <td>*/}
                {/*            </td>*/}
                {/*            <td valign='bottom'>*/}
                {/*            </td>*/}
                {/*        </tr>*/}
                {/*        <tr align="center">*/}
                {/*            <td align="center" valign="top">*/}
                {/*                <div tabindex="0"><ChessBoard position={currentFen} showNotation="false" width={width} /></div>*/}
                {/*            </td>*/}
                {/*            <td>*/}
                {/*            </td>*/}
                {/*            <td align="left" valign="top" style={{ maxHeight: width, overflow: 'auto', display: 'inline-block' }}>*/}
                {/*                <table className='table table-sm table-striped table-bordered' aria-labelledby="tabelLabel">*/}
                {/*                    <thead className="thead-dark" style={{ position: 'sticky', top: 0 }}>*/}
                {/*                        <tr>*/}
                {/*                            <th nowrap="nowrap" style={{ "textAlign": "center" }}>#</th>*/}
                {/*                            <th nowrap="nowrap" style={{ "textAlign": "center" }}>White</th>*/}
                {/*                            <th nowrap="nowrap" style={{ "textAlign": "center" }}>Black</th>*/}
                {/*                        </tr >*/}
                {/*                    </thead >*/}
                {/*                    <tbody>*/}
                {/*                        {notations.map((singleMove, index) =>*/}
                {/*                            <tr key={singleMove.index}>*/}
                {/*                                <td nowrap="nowrap" style={{ "textAlign": "right" }} ><span>{singleMove.moveIndex}</span></td>*/}
                {/*                                <td nowrap="nowrap" style={{ "textAlign": "center" }} className={currentMove === (singleMove.moveIndex - 1) * 2 + 1 ? "table-info" : null} tabindex={(singleMove.moveIndex - 1) * 2 + 1} onKeyDown={async (e) => { await handleKey(e) }}><span className="btn btn-link" onClick={async (e) => { await setCurrentFen(fenArray[(singleMove.moveIndex - 1) * 2 + 1]); await setCurrentMove((singleMove.moveIndex - 1) * 2 + 1) }}>{singleMove.white}</span></td>*/}
                {/*                                <td nowrap="nowrap" style={{ "textAlign": "center" }} className={currentMove === (singleMove.moveIndex - 1) * 2 + 2 ? "table-info" : null} tabindex={(singleMove.moveIndex - 1) * 2 + 2} onKeyDown={async (e) => { await handleKey(e) }}><span className="btn btn-link" onClick={async (e) => { await setCurrentFen(fenArray[(singleMove.moveIndex - 1) * 2 + 2]); await setCurrentMove((singleMove.moveIndex - 1) * 2 + 2) }}>{singleMove.black}</span></td>*/}
                {/*                            </tr>*/}
                {/*                        )}*/}
                {/*                    </tbody>*/}
                {/*                </table>*/}
                {/*            </td>*/}
                {/*        </tr>*/}
                {/*        <tr align="center">*/}
                {/*            <td>*/}
                {/*                <button className="btn btn-primary mt-1 mb-1" disabled={currentMove <= 0} onClick={async () => { await makeMove("start") }}>Start Position</button>*/}
                {/*                <button className="btn btn-primary ml-1 mt-1 mb-1" disabled={currentMove <= 0} onClick={async () => { await makeMove("prev") }}>Previous Move</button>*/}
                {/*                <button className="btn btn-primary ml-1 mt-1 mb-1" disabled={currentMove >= totalMoves} onClick={async () => { await makeMove("next") }}>Next Move</button>*/}
                {/*                <button className="btn btn-primary ml-1 mt-1 mb-1" disabled={currentMove >= totalMoves} onClick={async () => { await makeMove("end") }}>End Position</button>*/}
                {/*            </td>*/}
                {/*            <td>*/}
                {/*            </td>*/}
                {/*            <td>*/}
                {/*                {result &&*/}
                {/*                    <table className='table table-sm table-striped table-bordered' aria-labelledby="tabelLabel">*/}
                {/*                        <thead className="thead-dark">*/}
                {/*                            <tr>*/}
                {/*                                <th nowrap="nowrap" style={{ "textAlign": "center" }}>{result}</th>*/}
                {/*                            </tr >*/}
                {/*                        </thead >*/}
                {/*                    </table>*/}
                {/*                }*/}
                {/*            </td>*/}
                {/*        </tr>*/}
                {/*    </tbody>*/}
                {/*</table>*/}


                {/*<fieldset className="border p-2">*/}
                {/*    <legend className="float-none w-auto p-2">*/}
                {/*        Input Game : Players*/}
                {/*        {blackPlayer && whitePlayer && <span> | <span className="btn btn-link" onClick={async () => { var tmpPlayer = whitePlayer; await setWhitePlayer(blackPlayer); await setBlackPlayer(tmpPlayer) }}>Switch Color</span></span>}*/}
                {/*    </legend>*/}
                {/*    <div className="table-responsive">*/}
                {/*        <table className="table">*/}
                {/*            <tbody>*/}
                {/*                */}{/*{whitePlayer &&*/}
                {/*                */}{/*    <div>*/}
                {/*                */}{/*    <Stack direction='row'>*/}
                {/*                */}{/*        <ButtonGroup*/}
                {/*                */}{/*            variant='text'*/}
                {/*                */}{/*            size='small'*/}
                {/*                */}{/*            color='primary'*/}
                {/*                */}{/*            aria-label='White player button group'*/}
                {/*                */}{/*        >*/}
                {/*                */}{/*            <Button>{whitePlayer.fideTitle ? whitePlayer.fideTitle + " " : ""}{whitePlayer.fideName ? whitePlayer.fideName : whitePlayer.uscfName}</Button>*/}
                {/*                */}{/*            <Button>{whitePlayer.fidePlayerId ? (<a href={'https://ratings.fide.com/profile/' + whitePlayer.fidePlayerId} target='_blank' rel='noreferrer'>{" FIDE ID " + whitePlayer.fidePlayerId}</a>) : ""}</Button>*/}
                {/*                */}{/*            <Button>{whitePlayer.fidePlayerId ? " FIDE Elo " + whitePlayer.fideRating : ""}</Button>*/}
                {/*                */}{/*            <Button>{whitePlayer.uscfPlayerId ? (<a href={'http://www.uschess.org/msa/MbrDtlMain.php?' + whitePlayer.uscfPlayerId} target='_blank' rel='noreferrer'>{" USCF ID " + whitePlayer.uscfPlayerId}</a>) : ""}</Button>*/}
                {/*                */}{/*            <Button>{whitePlayer.uscfPlayerId ? " USCF Rating " + whitePlayer.uscfRating : ""}</Button>*/}
                {/*                */}{/*        </ButtonGroup>*/}
                {/*                */}{/*    </Stack>*/}
                {/*                */}{/*    <tr>*/}

                {/*                */}{/*        <div className="input-group">*/}
                {/*                */}{/*            <div className="input-group-prepend">*/}
                {/*                */}{/*                <span className="input-group-text" id="inputGroupFileAddon01">White</span>*/}
                {/*                */}{/*            </div>*/}
                {/*                */}{/*            <div className="input-group-prepend">*/}
                {/*                */}{/*                {whitePlayer &&*/}
                {/*                */}{/*                    <span className="input-group-text" >*/}
                {/*                */}{/*                        <strong>*/}
                {/*                */}{/*                            {whitePlayer.fideTitle ? whitePlayer.fideTitle + " " : ""}*/}
                {/*                */}{/*                            {whitePlayer.fideName ? whitePlayer.fideName : whitePlayer.uscfName}*/}
                {/*                */}{/*                            {whitePlayer.fidePlayerId ? (<a href={'https://ratings.fide.com/profile/' + whitePlayer.fidePlayerId} target='_blank' rel='noreferrer'>{" FIDE ID " + whitePlayer.fidePlayerId}</a>) : ""}*/}
                {/*                */}{/*                            {whitePlayer.fidePlayerId ? " FIDE Elo " + whitePlayer.fideRating : ""}*/}
                {/*                */}{/*                            {whitePlayer.uscfPlayerId ? (<a href={'http://www.uschess.org/msa/MbrDtlMain.php?' + whitePlayer.uscfPlayerId} target='_blank' rel='noreferrer'>{" USCF ID " + whitePlayer.uscfPlayerId}</a>) : ""}*/}
                {/*                */}{/*                            {whitePlayer.uscfPlayerId ? " USCF Rating " + whitePlayer.uscfRating : ""}*/}
                {/*                */}{/*                        </strong>*/}
                {/*                */}{/*                    </span>*/}
                {/*                */}{/*                }*/}
                {/*                */}{/*                {whitePlayer && !whitePlayerConfirmed &&*/}
                {/*                */}{/*                    <span className="btn btn-link" onClick={async () => { await setWhitePlayerConfirmed(true); }}>Confirm</span>*/}
                {/*                */}{/*                }*/}
                {/*                */}{/*                {whitePlayer && whitePlayerConfirmed &&*/}
                {/*                */}{/*                    <span className="btn btn-link" onClick={async () => { await setWhitePlayerConfirmed(false); await setWhitePlayer(null); }}>Clear</span>*/}
                {/*                */}{/*                }*/}

                {/*                */}{/*            </div>*/}
                {/*                */}{/*        </div>*/}
                {/*                */}{/*    </tr>*/}
                {/*                */}{/*    </div>*/}
                {/*                */}{/*}*/}
                {/*                {!whitePlayerConfirmed &&*/}
                {/*                    <tr>*/}
                {/*                        <td>*/}
                {/*                            <div><FindPlayers sendToParentSelectedPlayer={setWhitePlayer} searchButtonCaption={"Search White Player"} /></div>*/}
                {/*                        </td>*/}
                {/*                    </tr>*/}
                {/*                }*/}
                {/*                */}{/*{blackPlayer &&*/}
                {/*                */}{/*    <div>*/}
                {/*                */}{/*    <Stack direction='row'>*/}
                {/*                */}{/*        <ButtonGroup*/}
                {/*                */}{/*            variant='text'*/}
                {/*                */}{/*            size='small'*/}
                {/*                */}{/*            color='primary'*/}
                {/*                */}{/*            aria-label='Black player button group'*/}
                {/*                */}{/*        >*/}
                {/*                */}{/*            <Button>{blackPlayer.fideTitle ? blackPlayer.fideTitle + " " : ""} {blackPlayer.fideName ? blackPlayer.fideName : blackPlayer.uscfName}</Button>*/}
                {/*                */}{/*            <Button>{blackPlayer.fidePlayerId ? (<a href={'https://ratings.fide.com/profile/' + blackPlayer.fidePlayerId} target='_blank' rel='noreferrer'>{" FIDE ID " + blackPlayer.fidePlayerId}</a>) : ""}</Button>*/}
                {/*                */}{/*            <Button>{blackPlayer.fidePlayerId ? " FIDE Elo " + blackPlayer.fideRating : ""}</Button>*/}
                {/*                */}{/*            <Button>{blackPlayer.uscfPlayerId ? (<a href={'http://www.uschess.org/msa/MbrDtlMain.php?' + blackPlayer.uscfPlayerId} target='_blank' rel='noreferrer'>{" USCF ID " + blackPlayer.uscfPlayerId}</a>) : ""}</Button>*/}
                {/*                */}{/*            <Button>{blackPlayer.uscfPlayerId ? " USCF Rating " + blackPlayer.uscfRating : ""}</Button>*/}
                {/*                */}{/*    </ButtonGroup>*/}
                {/*                */}{/*    </Stack>*/}

                {/*                */}{/*    <tr>*/}
                {/*                */}{/*        <div className="input-group">*/}
                {/*                */}{/*            <div className="input-group-prepend">*/}
                {/*                */}{/*                <span className="input-group-text" id="inputGroupFileAddon01">Black</span>*/}
                {/*                */}{/*            </div>*/}
                {/*                */}{/*            <div className="input-group-prepend">*/}
                {/*                */}{/*                {blackPlayer &&*/}
                {/*                */}{/*                    <span className="input-group-text" >*/}
                {/*                */}{/*                        <strong>*/}
                {/*                */}{/*                            {blackPlayer.fideTitle ? blackPlayer.fideTitle + " " : ""}*/}
                {/*                */}{/*                            {blackPlayer.fideName ? blackPlayer.fideName : blackPlayer.uscfName}*/}
                {/*                */}{/*                            {blackPlayer.fidePlayerId ? (<a href={'https://ratings.fide.com/profile/' + blackPlayer.fidePlayerId} target='_blank' rel='noreferrer'>{" FIDE ID " + blackPlayer.fidePlayerId}</a>) : ""}*/}
                {/*                */}{/*                            {blackPlayer.fidePlayerId ? " FIDE Elo " + blackPlayer.fideRating : ""}*/}
                {/*                */}{/*                            {blackPlayer.uscfPlayerId ? (<a href={'http://www.uschess.org/msa/MbrDtlMain.php?' + blackPlayer.uscfPlayerId} target='_blank' rel='noreferrer'>{" USCF ID " + blackPlayer.uscfPlayerId}</a>) : ""}*/}
                {/*                */}{/*                            {blackPlayer.uscfPlayerId ? " USCF Rating " + blackPlayer.uscfRating : ""}*/}
                {/*                */}{/*                        </strong>*/}
                {/*                */}{/*                    </span>*/}
                {/*                */}{/*                }*/}
                {/*                */}{/*                {blackPlayer && !blackPlayerConfirmed &&*/}
                {/*                */}{/*                    <span className="btn btn-link" onClick={async () => { await setBlackPlayerConfirmed(true); }}>Confirm</span>*/}
                {/*                */}{/*                }*/}
                {/*                */}{/*                {blackPlayer && blackPlayerConfirmed &&*/}
                {/*                */}{/*                    <span className="btn btn-link" onClick={async () => { await setBlackPlayerConfirmed(false); await setBlackPlayer(null) }}>Clear</span>*/}
                {/*                */}{/*                }*/}
                {/*                */}{/*            </div>*/}
                {/*                */}{/*        </div>*/}
                {/*                */}{/*    </tr>*/}
                {/*                */}{/*    </div>*/}
                {/*                */}{/*}*/}
                {/*                {!blackPlayerConfirmed &&*/}
                {/*                    <tr>*/}
                {/*                        <td>*/}
                {/*                            <div><FindPlayers sendToParentSelectedPlayer={setBlackPlayer} searchButtonCaption={"Search Black Player"} /></div>*/}
                {/*                        </td>*/}
                {/*                    </tr>*/}
                {/*                }*/}
                {/*            </tbody>*/}
                {/*        </table>*/}
                {/*    </div>*/}

                {/*    {whitePlayer && blackPlayer && whitePlayerConfirmed && blackPlayerConfirmed &&*/}
                {/*        <div>*/}
                {/*            <ViewPlayerGames*/}
                {/*                key={whitePlayer.fidePlayerId + whitePlayer.uscfPlayerId + blackPlayer.fidePlayerId + blackPlayer.uscfPlayerId}*/}
                {/*                idType={whitePlayer.fidePlayerId > 0 ? "FIDE" : "USCF"}*/}
                {/*                playerId={whitePlayer.fidePlayerId > 0 ? whitePlayer.fidePlayerId : whitePlayer.uscfPlayerId}*/}
                {/*                opponentIdType={blackPlayer.fidePlayerId > 0 ? "FIDE" : "USCF"}*/}
                {/*                opponentPlayerId={blackPlayer.fidePlayerId > 0 ? blackPlayer.fidePlayerId : blackPlayer.uscfPlayerId}*/}
                {/*            />*/}
                {/*        </div>*/}
                {/*    }*/}

{/*</fieldset>*/ }




{/*<Stack m={2} pt={3} direction={{ xs: "column", sm: "column", md: "row" }} spacing={2}>*/ }
{/*    <TextField*/ }
{/*        required*/ }
{/*        fullwidth*/ }
{/*        size="small"*/ }
{/*        label='Event'*/ }
{/*        InputLabelProps={{ shrink: true, }}*/ }
{/*        variant='outlined'*/ }
{/*        value={event}*/ }
{/*        onChange={async (e) => { await setEvent(e.target.value) }}*/ }
{/*        error={!event}*/ }
{/*        helperText={ !event ? 'Required':''}*/ }
{/*    />*/ }
{/*    <TextField*/ }
{/*        required*/ }
{/*        fullwidth*/ }
{/*        size="small"*/ }
{/*        label='Section'*/ }
{/*        InputLabelProps={{ shrink: true, }}*/ }
{/*        variant='outlined'*/ }
{/*        value={section}*/ }
{/*        onChange={async (e) => { await setSection(e.target.value) }}*/ }
{/*        error={!section}*/ }
{/*        helperText={!section ? 'Required' : ''}*/ }
{/*    />*/ }
{/*    <TextField*/ }
{/*        fullwidth*/ }
{/*        size="small"*/ }
{/*        label='Round'*/ }
{/*        variant='outlined'*/ }
{/*        InputLabelProps={{ shrink: true, }}*/ }
{/*        type='number'*/ }
{/*        value={round}*/ }
{/*        onChange={async (e) => { await setRound(e.target.value) }}*/ }
{/*        error={!round}*/ }
{/*        helperText={!round ? 'Required' : ''}*/ }
{/*    />*/ }
{/*    <TextField*/ }
{/*        required*/ }
{/*        fullwidth*/ }
{/*        size="small"*/ }
{/*        label='Site'*/ }
{/*        variant='outlined'*/ }
{/*        InputLabelProps={{ shrink: true, }}*/ }
{/*        value={site}*/ }
{/*        onChange={async (e) => { await setSite(e.target.value) }}*/ }
{/*        error={!site}*/ }
{/*        helperText={!site ? 'Required' : ''}*/ }
{/*    />*/ }
{/*    <TextField*/ }
{/*        required*/ }
{/*        fullwidth*/ }
{/*        size="small"*/ }
{/*        label='Date'*/ }
{/*        InputLabelProps={{ shrink: true, }}*/ }
{/*        variant='outlined'*/ }
{/*        type='date'*/ }
{/*        value={date.replaceAll(".", "-")}*/ }
/*{*//*        onChange={async (e) => { await setDate(e.target.value.replaceAll("-", ".")) }}*//* }*/
{/*        error={!date}*/ }
{/*        helperText={!date ? 'Required' : ''}*/ }
{/*    />*/ }
{/*</Stack>*/ }
{/*<Stack fullwidth m={1} direction={{ xs: "column", sm: "column", md: "row" }} spacing={2} alignItems="center">*/ }
{/*    {whitePlayer &&*/ }
{/*        <Card >*/ }
{/*            <CardContent style={{ borderColor: "white" }}>*/ }
{/*                <TextField*/ }
{/*                    variant='outlined'*/ }
{/*                    size='small'*/ }
{/*                    label='White Player'*/ }
{/*                    readOnly*/ }
{/*                    fullwidth*/ }
{/*                    value={(whitePlayer.fideTitle ? whitePlayer.fideTitle + " " : "") + (whitePlayer.fideName ? whitePlayer.fideName : whitePlayer.uscfName) + (whitePlayer.fideCountry ? " [" + whitePlayer.fideCountry + "] " : "") + (whitePlayer.uscfState ? "[" + whitePlayer.uscfState + "] " : "")}*/ }
{/*                    helperText={(whitePlayer.fidePlayerId ? '[FIDE#' + whitePlayer.fidePlayerId + "|Elo " + whitePlayer.fideRating + "]" : "[FIDE#000000|Elo 0000]") + (whitePlayer.uscfPlayerId ? '[USCF#' + whitePlayer.uscfPlayerId + "|Rating " + whitePlayer.uscfRating + "]" : "[USCF#00000000|Rating 0000")}*/ }
{/*                >*/ }
{/*                </TextField>*/ }
{/*            </CardContent>*/ }
{/*            <CardActions>*/ }
{/*                <ButtonGroup variant='text' size='small' color='primary'>*/ }
{/*                    {whitePlayer && !whitePlayerConfirmed &&*/ }
{/*                        <Button variant='contained' onClick={async () => { await setWhitePlayerConfirmed(true); }}>Confirm</Button>*/ }
{/*                    }*/ }
{/*                    {whitePlayer && whitePlayerConfirmed &&*/ }
/*{*//*                        <Button onClick={async () => { await setWhitePlayerConfirmed(false); /*await setWhitePlayer(null);*//* }}> Change</Button >* /}*/
{/*                    }*/ }
{/*                </ButtonGroup>*/ }
{/*            </CardActions>*/ }
{/*        </Card>*/ }
{/*    }*/ }
{/*    {whitePlayerConfirmed && blackPlayerConfirmed &&*/ }
{/*        <Card >*/ }
{/*            <CardContent style={{ borderColor: "white" }}>*/ }
{/*                <FormControl>*/ }

{/*                    <RadioGroup row name='result-radio-group' value={result} onChange={(e) => setResult(e.target.value)}>*/ }
{/*                        <FormControlLabel control={<Radio checked={result == '1-0'} size='small' color='primary' />} label='1-0' value='1-0' />*/ }
{/*                        <FormControlLabel control={<Radio checked={result == '1/2-1/2'} size='small' color='secondary' />} label='Draw' value='1/2-1/2' />*/ }
{/*                        <FormControlLabel control={<Radio checked={result == '0-1'} size='small' color='primary' />} label='0-1' value='0-1' />*/ }
{/*                    </RadioGroup>*/ }
{/*                </FormControl>*/ }
{/*            </CardContent>*/ }
{/*            <CardActions >*/ }
{/*                <ButtonGroup variant='text' size='small' color='primary'>*/ }
{/*                    {blackPlayer && whitePlayer && blackPlayerConfirmed && whitePlayerConfirmed &&*/ }
{/*                        <Button onClick={async () => { var tmpPlayer = whitePlayer; await setWhitePlayer(blackPlayer); await setBlackPlayer(tmpPlayer) }}>Switch Color</Button>*/ }
{/*                    }*/ }
{/*                </ButtonGroup>*/ }
{/*            </CardActions>*/ }
{/*        </Card>*/ }
{/*    }*/ }
{/*    {blackPlayer &&*/ }
{/*        <Card >*/ }
{/*            <CardContent style={{ borderColor: "black" }}>*/ }
{/*                <TextField*/ }
{/*                    variant='outlined'*/ }
{/*                    size='small'*/ }
{/*                    label='Black Player'*/ }
{/*                    readOnly*/ }
{/*                    fullwidth*/ }
{/*                    value={(blackPlayer.fideTitle ? blackPlayer.fideTitle + " " : "") + (blackPlayer.fideName ? blackPlayer.fideName : blackPlayer.uscfName) + (blackPlayer.fideCountry ? " [" + blackPlayer.fideCountry + "] " : "") + (blackPlayer.uscfState ? "[" + blackPlayer.uscfState + "] " : "")}*/ }
{/*                    helperText={(blackPlayer.fidePlayerId ? '[FIDE#' + blackPlayer.fidePlayerId + "|Elo " + blackPlayer.fideRating + "]" : "[FIDE#000000|Elo 0000]") + (blackPlayer.uscfPlayerId ? '[USCF#' + blackPlayer.uscfPlayerId + "|Rating " + blackPlayer.uscfRating + "]" : "[USCF#00000000|Rating 0000")}*/ }
{/*                >*/ }
{/*                </TextField>*/ }
{/*            </CardContent>*/ }
{/*            <CardActions>*/ }
{/*                <ButtonGroup variant='text' size='small' color='primary'>*/ }
{/*                    {blackPlayer && !blackPlayerConfirmed &&*/ }
{/*                        <Button variant='contained' onClick={async () => { await setBlackPlayerConfirmed(true); }}>Confirm</Button>*/ }
{/*                    }*/ }
{/*                    {blackPlayer && blackPlayerConfirmed &&*/ }
/*{*//*                        <Button onClick={async () => { await setBlackPlayerConfirmed(false); /*await setBlackPlayer(null); *//* }}> Change</Button >* /}*/
{/*                    }*/ }
{/*                </ButtonGroup>*/ }
{/*            </CardActions>*/ }
{/*        </Card>*/ }
{/*    }*/ }
{/*</Stack>*/ }
{/*<Stack direction="column">*/ }
{/*    {!whitePlayerConfirmed &&*/ }
{/*        <div><FindPlayers sendToParentSelectedPlayer={setWhitePlayer} searchButtonCaption={"Search White Player"} /></div>*/ }
{/*    }*/ }
{/*    {!blackPlayerConfirmed &&*/ }
{/*        <div><FindPlayers sendToParentSelectedPlayer={setBlackPlayer} searchButtonCaption={"Search Black Player"} /></div>*/ }
{/*    }*/ }
{/*</Stack>*/ }
{/*<Stack>*/ }
{/*    {whitePlayer && blackPlayer && whitePlayerConfirmed && blackPlayerConfirmed &&*/ }
{/*        <div>*/ }
{/*            <ViewPlayerGames*/ }
{/*                key={whitePlayer.fidePlayerId + whitePlayer.uscfPlayerId + blackPlayer.fidePlayerId + blackPlayer.uscfPlayerId}*/ }
{/*                idType={whitePlayer.fidePlayerId > 0 ? "FIDE" : "USCF"}*/ }
{/*                playerId={whitePlayer.fidePlayerId > 0 ? whitePlayer.fidePlayerId : whitePlayer.uscfPlayerId}*/ }
{/*                opponentIdType={blackPlayer.fidePlayerId > 0 ? "FIDE" : "USCF"}*/ }
{/*                opponentPlayerId={blackPlayer.fidePlayerId > 0 ? blackPlayer.fidePlayerId : blackPlayer.uscfPlayerId}*/ }
{/*            />*/ }
{/*        </div>*/ }
{/*    }*/ }
{/*</Stack>*/ }